import { PROYECT } from "services/api";
import { reportDigitalInventoryTypes } from "redux/reducers/Reports/reportDigitalInventory/types";
import { saveAs } from 'file-saver';
import axios from "axios";
import { setSnackbar, startRequestComp, stopRequestComp } from "redux/actions/search/searchActions";
import { getErrorBlob } from "helpers/extractError";
const { SET_REPORT_DIGITAL_INVENTORY_FILTERS } = reportDigitalInventoryTypes


export const getReportDigitalInventoryAction = ({ date, station, isPdf = true }) => {
  return async (dispatch, getState) => {
    const token = getState().login.token || localStorage.getItem('crm-user');
    const auth = { headers: { authorization: token } };
    const reportUrl = `${process.env.REACT_APP_URL}${PROYECT}/digital-inventory/report?station=${station.id}&date=${date}&pdf=${isPdf}`;
    const fileName = `Reporte_Inventario_Digital_${station.name}_${date}.${isPdf ? `pdf` : `xlsx`}`;

    dispatch(startRequestComp('loadingReportDigitalInventory'))
    const access = {
      url: reportUrl,
      method: 'GET',
      responseType: 'blob',
      ...auth
    }
    try {
      const pdf = await axios(access)
      saveAs(pdf.data, fileName)
      dispatch(setSnackbar(`${isPdf ? `PDF` : `Excel`} Descargado con éxito`, "success"))
    } catch (err) {
      dispatch(setSnackbar(await getErrorBlob(err)))
    } finally {
      dispatch(stopRequestComp('loadingReportDigitalInventory'))
    }
  }
}

export const setReportDigitalInventoryFilters = (key = "", value) => {
  return {
    type: SET_REPORT_DIGITAL_INVENTORY_FILTERS,
    payload: { value, key }
  }
}
